import { combineReducers } from 'redux';
import { fork } from 'redux-saga/effects';

// Documents
import documentsReducers from './documents/reducers';
import documentsSagas from './documents/sagas';
import type { IDocumentsState } from './documents/types';

// Recipients
import propertiesReducers from './properties/reducer';
import propertiesSaga from './properties/saga';
import type { IPropertiesState } from './properties/types';
import recipientReducers from './recipients/reducers';
import recipientsSagas from './recipients/sagas';

// Properties
import type { IRecipientsState } from './recipients/types';

export interface IDTMState {
  documents: IDocumentsState;
  recipients: IRecipientsState;
  properties: IPropertiesState;
}

export const dtmReducers = combineReducers({
  documents: documentsReducers,
  recipients: recipientReducers,
  properties: propertiesReducers,
});

export const dtmSagas = [fork(documentsSagas), fork(recipientsSagas), fork(propertiesSaga)];
